import { Box, Typography } from '@mui/material'
import { NavBar } from './Navigation'
import { useState } from 'react'
import { StickerPickup } from '../shared/sticker/StickerBar'
import { useWindowSize } from '../shared/useWindowSize'

export function StickerWall() {
  const [isOpen, setIsOpen] = useState(false)

  const stickerIds = Array(54)
    .fill(null)
    .map((_, i) => `emoji_${i + 1}.png`)

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',

          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>

      <Box sx={{ position: 'absolute', top: '50%', zIndex: 1 }}>
        <Typography
          variant="body1"
          paragraph
          fontWeight={'bold'}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? '- STICKER WALL' : '+ STICKER WALL'}
        </Typography>
      </Box>

      {isOpen && (
        <Box
          sx={{
            maxWidth: '90%',
            borderTop: '3px solid black',
            borderLeft: '3px solid black',
            borderRight: '3px solid black',
            borderRadius: '2px',
            padding: '10px',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 1.0)',

            flexWrap: 'wrap',
          }}
        >
          {stickerIds.map(id => (
            <StickerPickup key={id} stickerId={id}></StickerPickup>
          ))}
        </Box>
      )}
    </Box>
  )
}
